import { Dto } from '@core/data/dto/dto';
import { DtoImport } from '@core/utils/dto';
import { Moment } from 'moment';
import { DeliveryOrderManagerNoteSchema } from './delivery-order-manager-note.schema';

export class DeliveryOrderManagerNote {
    public note: string;
    public createAt: Moment;
    public createdBy: string;

    @DtoImport(DeliveryOrderManagerNoteSchema)
    static import(dto: Dto): any {}
}
